var render, staticRenderFns
import script from "./ErrorPageWrapper.vue?vue&type=script&lang=js&"
export * from "./ErrorPageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ErrorPageWrapper.vue?vue&type=style&index=0&id=0f186422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f186422",
  null
  
)

export default component.exports